import { ContainerModule } from '@evertel/di'
import { ChildDepartmentStore } from './ChildDepartmentStore'
import { IntegrationStore } from './IntegrationStore'
import { MessageDraftStore } from './MessageDraftStore'
import { RoomStore } from './RoomStore'
import { RoomMessagesStore } from './RoomMessagesStore'
import { ReplyMessagesStore } from './ReplyMessagesStore'
import { ThreadMessagesStore } from './ThreadMessagesStore'
import { ThreadStore } from './ThreadStore'
import { UserSettingsStore } from './UserSettingsStore'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(RoomStore).toSelf().inSingletonScope()
        m.bind(RoomMessagesStore).toSelf().inSingletonScope()
        m.bind(ReplyMessagesStore).toSelf().inSingletonScope()
        m.bind(ThreadMessagesStore).toSelf().inSingletonScope()
        m.bind(ThreadStore).toSelf().inSingletonScope()
        m.bind(UserSettingsStore).toSelf().inSingletonScope()
        m.bind(ChildDepartmentStore).toSelf().inSingletonScope()
        m.bind(IntegrationStore).toSelf().inSingletonScope()
        m.bind(MessageDraftStore).toSelf().inSingletonScope()
    })
]

export { DI_MODULES }
